export const DEFAULT_DECIMALS = 2;
export const MIN_FRACTION_DIGITS_ACCURACY = 0;
export const MAX_FRACTION_DIGITS_ACCURACY = 20;
export const TYPE_SUM = "sum";
export const TYPE_AVERAGE = "average";
